/**
 * Calculates the width adjustment needed for the PageTitle component, to prevent overflow on small screens.
 * based on the presence of various UI elements.
 *
 * @param {boolean} showEducationIcon - Whether the education icon is shown.
 * @param {boolean} isPdfDownloadButton - Whether the PDF download button is shown.
 * @param {boolean} hasExcelDownloadButton - Whether the Excel download button is shown.
 * @returns {number} - The total width to reduce.
 */
export const calculateWidthToReduce = (
    showEducationIcon: boolean,
    isPdfDownloadButton: boolean,
    hasExcelDownloadButton: boolean,
): number => {
    const EXCEL_BUTTON_WIDTH = 112;
    const EDUCATION_BANNER_WIDTH = 40;
    const PDF_ICON_WIDTH = 80;

    return (
        (showEducationIcon ? EDUCATION_BANNER_WIDTH : 0) +
        (isPdfDownloadButton ? PDF_ICON_WIDTH : 0) +
        (hasExcelDownloadButton ? EXCEL_BUTTON_WIDTH : 0)
    );
};
